export default "__VITE_ASSET__DPoZhdsL__"